
// export const IMG_URL = "http://192.168.16.23:2007";
export const IMG_URL = "http://node.khadyalay.profcyma.org:2007";


export const Select2Data = async (data, name, model = false, other = false) => {
  const result = data.map((item) => ({
    value: item?.[name] ?? item?.id,
    label: item?.name ?? item?.f_name,
    icon: model ? item?.[model]?.image : null,
    name: name,
  }));


  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};


export const getToday = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export const getTwoWeeksAgo = (days = 14) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date.toISOString().split("T")[0];
};

export const formatAmount = (amount) =>
  Number(amount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const handleDecimalKeyDown = (e) => {
  const allowedKeys = [
    "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete",
    ".", "Home", "End"
  ];
  const isNumber = /^[0-9]$/.test(e.key);

  if (!isNumber && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }

  // Prevent multiple dots
  if (e.key === "." && e.currentTarget.value.includes(".")) {
    e.preventDefault();
  }
};

export const formatDate = (dateString, newFormat = false) => {
  if (newFormat) {
    const date = new Date(dateString);

    const pad = (n) => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);  // Months are zero-based
    const day = pad(date.getDate());

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  if (!dateString) return '';
  const date = new Date(dateString);
  return `${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'

}


export const getWeekRange = (type = "current") => {
  const today = new Date();
  const day = today.getDay(); // 0 (Sun) - 6 (Sat)

  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(today);
  monday.setDate(today.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  if (type === "last") {
    monday.setDate(monday.getDate() - 7);
    sunday.setDate(sunday.getDate() - 7);
  }

  return {
    startDate: monday,
    endDate: sunday,
  };
};

export const Last_Login = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    // second: '2-digit',
    hour12: true, // Set to true for AM/PM format
  }; const time = date.toLocaleTimeString('en-US', options);
  return `${time} on ${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'
}


export const fetchProductImage = async (query) => {
  console.log({ query });

  if (!query) return null;
  const apiKey = 'AIzaSyDOM_ARoA-aop1-vKIIMMn3-tgiN6OS140';
  const cx = 'd5f8188d80f3d4808';

  const url = `https://www.googleapis.com/customsearch/v1?q=${query}&cx=${cx}&searchType=image&num=1&key=${apiKey}`;

  try {
    const response = await fetch(url);
    const json = await response.json();
    const imageUrl = json?.items?.[0]?.link || null;
    return imageUrl;
  } catch (error) {
    console.log('Image fetch error:', error);
    return null;
  }
}

